import { Route, Redirect } from "react-router-dom";

export const PrivateRoute = ({ path, component }) => {
    const data = localStorage.getItem('bookyourgift-admin');

    return data ? <Route path={path} component={component} /> : <Redirect to="/auth" />
}